import { useState } from "react";
import { ColorSwatch, Group, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FilterSelect } from "@/Components/ui";
import { AD_STATUS, DESIGN_STATUS } from "@/Constants/adStatus";
import classes from "@/Components/ui/FilterSelect.module.css";

// AD-222: every status a submitted briefing can have, in the order of the loop.
export const DESIGN_REQUEST_STATUSES = [
    { value: DESIGN_STATUS.IN_DESIGN.code, key: 'inDesign', color: DESIGN_STATUS.IN_DESIGN.color },
    { value: DESIGN_STATUS.FEEDBACK.code, key: 'feedback', color: DESIGN_STATUS.FEEDBACK.color },
    { value: DESIGN_STATUS.IN_APPROVAL.code, key: 'inApproval', color: DESIGN_STATUS.IN_APPROVAL.color },
    { value: DESIGN_STATUS.APPROVED.code, key: 'approved', color: DESIGN_STATUS.APPROVED.color },
    { value: 'booked', key: 'booked', color: AD_STATUS.PUBLISHED.color },
];

/**
 * AD-222: the "All Status" filter of the Design Request list — the same control as
 * the other lists' status filters.
 */
export const DesignRequestStatusFilterSelect = ({ onChange, ...props }) => {
    const { t } = useTranslation();
    const [value, setValue] = useState('');
    const options = [
        { value: '', label: t('designRequests.status.all') },
        ...DESIGN_REQUEST_STATUSES.map((status) => ({
            value: status.value,
            label: t(`designRequests.status.${status.key}`),
            dotColor: status.color,
        })),
    ];

    return (
        <FilterSelect
            placeholder={t('designRequests.status.all')}
            w={170}
            data={options}
            value={value}
            renderOption={({ option }) => (
                <Group gap={8} wrap="nowrap">
                    {option.dotColor && <ColorSwatch color={option.dotColor} size={8} withShadow={false} />}
                    <Text fz={14} fw={400} className={classes.optionText} c="var(--option-fg)">{option.label}</Text>
                </Group>
            )}
            onChange={(val) => {
                setValue(val ?? '');
                onChange?.(val || null);
            }}
            {...props}
        />
    );
};
